// @flow

import CategoriesApi from './CategoriesApi';
import PlacesApi from './PlacesApi';
import ContactApi from './ContactApi';
import BrandsApi from './BrandsApi';

const host = process.env.REACT_APP_API_HOST;

export interface AppApi {
  categories: CategoriesApi;
  places: PlacesApi;
  contact: ContactApi;
  brands: BrandsApi;
}

const Api: AppApi = {
  categories: new CategoriesApi(host),
  places: new PlacesApi(host),
  contact: new ContactApi(host),
  brands: new BrandsApi(host),
};

export default Api;



// WEBPACK FOOTER //
// ./src/api/index.js